import { render } from "./ProductModelElementsChangeTab.vue?vue&type=template&id=5d4551e1&scoped=true"
import script from "./ProductModelElementsChangeTab.vue?vue&type=script&lang=js"
export * from "./ProductModelElementsChangeTab.vue?vue&type=script&lang=js"

import "./ProductModelElementsChangeTab.vue?vue&type=style&index=0&id=5d4551e1&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4551e1"]])

export default __exports__